import { createContext } from 'react';
import { ProjectFinancialsFieldNames } from 'api/project';
import { GranularPermissions } from 'hooks/use-has-access';

export type ProjectFinancialsSettingsFields = Extract<
  | 'projectBudget'
  | 'projectHours'
  | 'projectCustomBillRate'
  | 'projectRateCardUpdate'
  | 'projectProfitability',
  ProjectFinancialsFieldNames
>;

export interface ProjectFinancialsSettingsContextProps {
  permissionsMap: {
    [key in ProjectFinancialsSettingsFields]: GranularPermissions;
  };
}

export const ProjectFinancialsSettingsContext =
  createContext<ProjectFinancialsSettingsContextProps>(
    {} as ProjectFinancialsSettingsContextProps,
  );
